/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types */

import { ElementRef         } from '@angular/core';
import { Logger             } from '@/util/logger';
import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';

/**
 *
 * @class Dialog
 *
 * @brief base class for modal dialog.  Dialogs that need external validation will use a promise
 * to call the optionally provided validation callback (IValidatorCallBack), or just use a promise
 * directly.  This ensures we can do validation even if its asynchronous...maybe the validation
 * requires a network call for example.  Additionally, the users of dialogs can optionally provide a
 * success callback (IOkCallBack) that will be executed when the dialog is accepted.
 *
 * Tutorial on typing callbacks
 * @link https://www.bennadel.com/blog/3217-defining-function-and-callback-interfaces-in-typescript.htm
 *
 * Tutorial on using promises:
 * @link https://codecraft.tv/courses/angular/es6-typescript/promises/
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class Dialog {

  /** the hosting DOM */
  protected   host:        ElementRef = null;

  /** this dialog uses the Ok button */
  public     hasOk:           boolean = true;

  /** this dialog uses the Cancel button */
  public hasCancel:           boolean = true;

  /** this dialog is a Wizard */
  public isWizard:            boolean = false;

  /** dialog title */
  public    title:              string = 'No Title';

  /** dialog icon */
  public     icon:              string = '';

  /** optional validation callback */
  public validator: IValidatorCallBack = null;

  /** optional success callback */
  public   success: IOkCallBack        = null;

  /** standard constructor, allow for partial alert to be given */
  constructor(host: ElementRef) {

    this.host = host;

  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    if (options) {

      if (options.title) {

        this.title = options.title;
      }
    }
  }

  /** dialog is closing */
  public close() {

  }

  /** dialog was accepted */
  public ok() {

  }
}


